module.exports = __webpack_public_path__ + "media/images/icons/smp_optimize_score-41ca01f4f09dbbe7ae9fbe92a82436e6.svg";